/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardCompetitionResponse } from './LeaderboardCompetitionResponse';
import {
    LeaderboardCompetitionResponseFromJSON,
    LeaderboardCompetitionResponseFromJSONTyped,
    LeaderboardCompetitionResponseToJSON,
    LeaderboardCompetitionResponseToJSONTyped,
} from './LeaderboardCompetitionResponse';

/**
 * 
 * @export
 * @interface GetLeaderboardCompetitionsResponse
 */
export interface GetLeaderboardCompetitionsResponse {
    /**
     * 
     * @type {Array<LeaderboardCompetitionResponse>}
     * @memberof GetLeaderboardCompetitionsResponse
     */
    leaderboards: Array<LeaderboardCompetitionResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetLeaderboardCompetitionsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetLeaderboardCompetitionsResponse
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof GetLeaderboardCompetitionsResponse
     */
    offset: number;
}

/**
 * Check if a given object implements the GetLeaderboardCompetitionsResponse interface.
 */
export function instanceOfGetLeaderboardCompetitionsResponse(value: object): value is GetLeaderboardCompetitionsResponse {
    if (!('leaderboards' in value) || value['leaderboards'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function GetLeaderboardCompetitionsResponseFromJSON(json: any): GetLeaderboardCompetitionsResponse {
    return GetLeaderboardCompetitionsResponseFromJSONTyped(json, false);
}

export function GetLeaderboardCompetitionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeaderboardCompetitionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboards': ((json['leaderboards'] as Array<any>).map(LeaderboardCompetitionResponseFromJSON)),
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function GetLeaderboardCompetitionsResponseToJSON(json: any): GetLeaderboardCompetitionsResponse {
    return GetLeaderboardCompetitionsResponseToJSONTyped(json, false);
}

export function GetLeaderboardCompetitionsResponseToJSONTyped(value?: GetLeaderboardCompetitionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboards': ((value['leaderboards'] as Array<any>).map(LeaderboardCompetitionResponseToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

